export default __webpack_public_path__ + "static/media/info-blue-light.31bf9bc5.svg";